/**
 * Mapping between bible-tools numeric book IDs (1-66) and USFX book IDs used in prettybible
 */
export const BOOK_ID_MAP: Record<number, string> = {
  // Old Testament
  1: 'GEN',   // Genesis
  2: 'EXO',   // Exodus
  3: 'LEV',   // Leviticus
  4: 'NUM',   // Numbers
  5: 'DEU',   // Deuteronomy
  6: 'JOS',   // Joshua
  7: 'JDG',   // Judges
  8: 'RUT',   // Ruth
  9: '1SA',   // 1 Samuel
  10: '2SA',  // 2 Samuel
  11: '1KI',  // 1 Kings
  12: '2KI',  // 2 Kings
  13: '1CH',  // 1 Chronicles
  14: '2CH',  // 2 Chronicles
  15: 'EZR',  // Ezra
  16: 'NEH',  // Nehemiah
  17: 'EST',  // Esther
  18: 'JOB',  // Job
  19: 'PSA',  // Psalms
  20: 'PRO',  // Proverbs
  21: 'ECC',  // Ecclesiastes
  22: 'SNG',  // Song of Solomon
  23: 'ISA',  // Isaiah
  24: 'JER',  // Jeremiah
  25: 'LAM',  // Lamentations
  26: 'EZK',  // Ezekiel
  27: 'DAN',  // Daniel
  28: 'HOS',  // Hosea
  29: 'JOL',  // Joel
  30: 'AMO',  // Amos
  31: 'OBA',  // Obadiah
  32: 'JON',  // Jonah
  33: 'MIC',  // Micah
  34: 'NAM',  // Nahum
  35: 'HAB',  // Habakkuk
  36: 'ZEP',  // Zephaniah
  37: 'HAG',  // Haggai
  38: 'ZEC',  // Zechariah
  39: 'MAL',  // Malachi

  // New Testament
  40: 'MAT',  // Matthew
  41: 'MRK',  // Mark
  42: 'LUK',  // Luke
  43: 'JHN',  // John
  44: 'ACT',  // Acts
  45: 'ROM',  // Romans
  46: '1CO',  // 1 Corinthians
  47: '2CO',  // 2 Corinthians
  48: 'GAL',  // Galatians
  49: 'EPH',  // Ephesians
  50: 'PHP',  // Philippians
  51: 'COL',  // Colossians
  52: '1TH',  // 1 Thessalonians
  53: '2TH',  // 2 Thessalonians
  54: '1TI',  // 1 Timothy
  55: '2TI',  // 2 Timothy
  56: 'TIT',  // Titus
  57: 'PHM',  // Philemon
  58: 'HEB',  // Hebrews
  59: 'JAS',  // James
  60: '1PE',  // 1 Peter
  61: '2PE',  // 2 Peter
  62: '1JN',  // 1 John
  63: '2JN',  // 2 John
  64: '3JN',  // 3 John
  65: 'JUD',  // Jude
  66: 'REV'   // Revelation
};

/**
 * Convert bible-tools numeric book ID to USFX book ID
 */
export function mapBookIdToUsfx(bookId: number): string | null {
  return BOOK_ID_MAP[bookId] || null;
}

/**
 * Reverse mapping: USFX book ID to numeric book ID
 */
export const REVERSE_BOOK_ID_MAP: Record<string, number> = Object.fromEntries(
  Object.entries(BOOK_ID_MAP).map(([numId, usfxId]) => [usfxId, parseInt(numId)])
);

/**
 * Convert USFX book ID to bible-tools numeric book ID
 */
export function mapUsfxToBookId(usfxId: string): number | null {
  return REVERSE_BOOK_ID_MAP[usfxId] || null;
}